module.exports = __webpack_public_path__ + "media/images/announceGroup__icon-8542bdfc470b91c75749bdbaa777e27b.png";